import { ACTIVE_COMPONENT } from "../actions/types";

export default (val = "", action) => {
  if (action.type === ACTIVE_COMPONENT) {
    return action.payload;
  }
  return val;
};
